import { Component, OnInit, Inject } from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-modal-candidati',
  templateUrl: './modal-candidati.component.html',
  styleUrls: ['./modal-candidati.component.scss']
})
export class ModalCandidatiComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalCandidatiComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  close(){
    this.dialogRef.close();
  }
}
